export default __webpack_public_path__ + "f2704c71f3eb2c8d3401c102c26e453d.svg";